"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledViewInlineAssessmentItem = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledViewInlineAssessmentItem = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .item-indicators {\n    padding: ", ";\n    display: flex;\n    margin: 0;\n    width: auto;\n\n    > h2 {\n      margin: 0;\n\n      > div {\n        margin: 0;\n        width: auto;\n\n        span {\n          border-color: ", ";\n        }\n      }\n    }\n\n    & > .question-number {\n      display: flex;\n      padding-left: ", ";\n      color: ", ";\n      font-family: ", ";\n      font-size: ", ";\n    }\n  }\n"], ["\n  .item-indicators {\n    padding: ", ";\n    display: flex;\n    margin: 0;\n    width: auto;\n\n    > h2 {\n      margin: 0;\n\n      > div {\n        margin: 0;\n        width: auto;\n\n        span {\n          border-color: ", ";\n        }\n      }\n    }\n\n    & > .question-number {\n      display: flex;\n      padding-left: ", ";\n      color: ", ";\n      font-family: ", ";\n      font-size: ", ";\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x4, " 0 ").concat(Spacing.x2);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.quicksandFontFamily;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
});
var templateObject_1;
